import React from 'react';
import ConfirmParticipantsDF
  from '../components/SimulatorsComponents/DefualtSimulators/ConfirmParticipantsDF';

//= ========================================================================
const Sim_G02_SplitPaymentConfirmParticipant = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs = null,
}) => (
  <ConfirmParticipantsDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_G02_SplitPaymentConfirmParticipant;
